import { FunctionComponent, useMemo } from "react";
import { observer } from "mobx-react-lite";

import type { IconProp } from "@fortawesome/fontawesome-svg-core";

import { ActionButton } from "../ActionButton/ActionButton";

import "./ProgressButton.scss";

interface IProgressButtonProps {
  progressText?: string | undefined;
  tooltip?: string;
  disabled?: boolean;
  onClick?: (event: React.MouseEvent<HTMLButtonElement> | React.KeyboardEvent<HTMLButtonElement>) => void;
  label: string;
  icon: IconProp;
}

const RawProgressButton: FunctionComponent<IProgressButtonProps> = (props: IProgressButtonProps) => {
  const inProgress = useMemo(() => !!props.progressText?.length, [props.progressText]);
  const disabled = useMemo(() => inProgress || !!props.disabled, [inProgress, props.disabled]);

  return (
    <ActionButton
      id="progress-button"
      buttonDisabled={disabled}
      icon={inProgress ? undefined : props.icon}
      isLoading={inProgress}
      label={inProgress ? props.progressText : props.label}
      tooltip={props.tooltip}
      onClick={event => props.onClick?.(event)}
      showBackground
    />
  );
};

export const ProgressButton = observer(RawProgressButton);
